
import { defineComponent } from "vue";
import TitlebarButtons from "@/components/shared/TitlebarButtons.vue"; // @ is an alias to /src
import axios from "axios";

export default defineComponent({
  name: "Notes",
  components: {
    TitlebarButtons
  },
  data: () => ({
    title: "Notizen",
    current: 0,
    notes: [] as string[]
  }),
  emits: ["update-focus", "update-maximization"],
  created: function() {
    axios
      .get("./_content/notes.json")
      .then((response) => {
        this.notes = response.data;
        this.current = this.notes?.length - 1;
      })
      .catch((error) => console.error(error));
  },
  methods: {
    updateFocus(focusValue: string) {
      this.$emit("update-focus", focusValue);
    },
    updateMaximization() {
      this.$emit("update-maximization", "notes");
    },
    getWidth() {
      return window.innerWidth;
    }
  }
});
